
import { useTranslation } from "react-i18next";
import styles from "./SurveyCaseUser.module.scss";
import { useState } from "react";
import Notification from "utils/Notifications";
import PartSurveyAdminUsed from "./components/PartSurveyAdminUsed"
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Icon } from 'components'
const SurveyCaseUser = ({title_dat, item, index, setRender, partUserSurveys, partSurveySurveys }) => {
 const { t } = useTranslation("common");
 const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });


    const [showUserInfo_det, setShowUserInfoForm] = useState(null);
    const [partUserSurveys_det, setPartUserSurveys_det] = useState(null);
    const handleShowForm = (id) => {
        const filteredData = (partUserSurveys || []).find(item => item.id === id);

        setShowUserInfoForm(id);
        setPartUserSurveys_det(filteredData)
    };


    return (
        <>
        <button className={styles.btn_print} onClick={handlePrint}>{t('common.print')} <Icon name="print" /></button>
        <div  ref={componentRef}  className={styles.test_card}>
        <div className={styles.div_print}><h4>{t('surveys.report.report_by_survey')}: {title_dat} </h4><h4>{t('surveys.report.report_date')}: {new Date().toLocaleString("ru-RU")}</h4> </div>
            {showUserInfo_det === null ? (
                <>
                    <div className="table-container">
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>

                                    <th className={styles.test_row_title}>№</th>
                                    <th className={styles.test_row_title}>{t('surveys.case.user')}</th>
                                    <th className={styles.test_row_title}>{t('surveys.case.start_date')}</th>
                                    <th className={styles.test_row_title}>{t('surveys.case.end_date')}</th>
                                    <th className={styles.test_row_title}>{t('surveys.case.time_spent')}</th>
                                    <th className={styles.test_row_title}>{t('surveys.case.question_count')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {partUserSurveys.map((item, index) =>
                               
                                    <tr className={styles.tr_element} onClick={() => handleShowForm(item.id)} style={{ backgroundColor: item.admin_checked === true ? '#ffe8e8' : "#fff" }}>
                                        <td className={styles.test_row_title}>{index + 1}</td>
                                        <td className={styles.test_row_title} style={{textAlign:"left"}}><>{item.employee_name ? item.employee_name : item.full_name}</></td>
                                        <td className={styles.test_row_title}><>{item.createdAt}</></td>
                                        <td className={styles.test_row_title}><>{item.endAt}</></td>
                                        <td className={styles.test_row_title}><>{item.time_response}</></td>
                                        <td className={styles.test_row_title}><>{item.working_info}</></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (<>
                <div className="table-container">
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th className={styles.test_row_title}>{t('surveys.case.user')}</th>
                                <th className={styles.test_row_title}>{t('surveys.case.start_date')}</th>
                                <th className={styles.test_row_title}>{t('surveys.case.end_date')}</th>
                                <th className={styles.test_row_title}>{t('surveys.case.time_spent')}</th>
                                <th className={styles.test_row_title}>{t('surveys.case.question_count')}</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr >
                                <td className={styles.test_row_title} ><>{partUserSurveys_det.employee_name ? partUserSurveys_det.employee_name : partUserSurveys_det.full_name}</></td>
                                <td className={styles.test_row_title}><>{partUserSurveys_det.createdAt}</></td>
                                <td className={styles.test_row_title}><>{partUserSurveys_det.endAt}</></td>
                                <td className={styles.test_row_title}><>{partUserSurveys_det.time_response}</></td>
                                <td className={styles.test_row_title}><>{partUserSurveys_det.working_info}</></td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <PartSurveyAdminUsed setShowUserInfoForm={setShowUserInfoForm} data={partSurveySurveys} usedata={partUserSurveys_det} setRender={setRender} />
            </>
            )

            }


            <Notification notify={notify} setNotify={setNotify} />
        </div >

        </>


    );
};

export default SurveyCaseUser;
